module.exports = __webpack_public_path__ + "static/media/nick_fancy.a09adf72.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/about/nick_fancy.jpg
// module id = 266
// module chunks = 0